import { render, staticRenderFns } from "./AppSimpleDistrictSelector.vue?vue&type=template&id=2b485b2b&scoped=true&"
import script from "./AppSimpleDistrictSelector.vue?vue&type=script&lang=ts&"
export * from "./AppSimpleDistrictSelector.vue?vue&type=script&lang=ts&"
import style0 from "./AppSimpleDistrictSelector.vue?vue&type=style&index=0&id=2b485b2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b485b2b",
  null
  
)

export default component.exports